import { makeStyles } from '@material-ui/core/';

const useStyles = makeStyles((theme) => ({
  chipAddress: {
    margin: theme.spacing(0.5),
    backgroundColor: theme.palette.warning.light,
    width: '100%',
  },
  chip: {
    margin: theme.spacing(0.5),
  },
  closeButton: {
    position: 'absolute',
    right: theme.spacing(0.25),
    top: theme.spacing(0.25),
    color: theme.palette.grey[500],
  },
  dialogTitleText: {
    fontSize: '1.1rem',
    fontWeight: 500,
  },
  dialogTitle: {
    padding: '16px 60px 16px 16px',
  },
  dialogContent: {
    padding: '16px 10px',
  },
  tooltip: {
    backgroundColor: theme.palette.common.black,
  },
}));

export default useStyles;
